import { TableFilterReference } from '@omnea-app/packages/universal/tables/tableFilterReference'

export const tableFiltersQueryKey = 'tableFilters' as const

export const tableFiltersQueryKeys = {
  listTableFilters: [tableFiltersQueryKey, 'list'] as const,
  getTableFilterById: (id: string) => [tableFiltersQueryKey, 'detail', id] as const,
  getTableFiltersByReference: (reference?: TableFilterReference) => [tableFiltersQueryKey, 'filter', reference] as const,
}
